module.exports = __webpack_public_path__ + "img/affiche-ncy.cf7bdf4.jpeg";